const common = {
    data() {
        return {
            search: '',
            loader: false,
            numRules: [value => !isNaN(parseFloat(value)) || "This field is required."],
            requiredRules: [value => !!value || "This field is required."],
            phoneRules: [
                v => !!v || "Phone number is required.",
                v =>
                    /^(0)([0-9]{9})$/.test(v) ||
                    "Phone number format should be: 0xxxxxxxxx"
            ],
            dateRules: [
                v => !!v || "Date is required."
            ],
            emailRules: [
                v => !!v || "E-mail is required",
                v => /.+@.+\..+/.test(v) || "E-mail must be valid"
            ],
            uploadRules: [
                v => !!v || this.iseditmode ? true : "Upload is required.",
            ],
            custom_notification: [],
            menus: [ 
                {
                    title: "Map",
                    icon: "mdi-map",
                    to: "/account/dashboard" 
                },
                {
                    icon: "mdi-car",
                    title: "Asset Info",
                    to: "/account/asset_info" 
                },
                {
                    icon: "mdi-map-marker-path",
                    title: "Trips",
                    to: "/account/trips" 
                },
                // {
                //     icon: "mdi-map-marker",
                //     title: "Zones",
                //     to: "/account/dashboard" 
                // },
                {
                    icon: "mdi-bell",
                    title: "Alerts",
                    to: "/account/alerts" 
                },
                {
                    title: "Reports",
                    icon: "mdi-file-multiple-outline",
                    to: "/account/reports" 
                }, 
            ]
        }
    },
    methods: {
        ...mapMutations(["SET_NOTIFICATION"]), 
        ...mapActions(["logout"]),
        setNotification(t, m) {
            this.custom_notification["msg"] = m;
            this.custom_notification["type"] = t;
            this.$store.commit("SET_NOTIFICATION", this.custom_notification);
        }, 
        

        http_connect(endpoint, payload) {
            this.loader = true; 
            
            return this.$http
                .post(endpoint, payload, {
                    headers: {
                        'Content-Type': 'application/json',
                        // 'User-Agent':'Mozilla/5.0 (Windows NT 6.2; WOW64; rv:17.0) Gecko/20100101 Firefox/17.0'
                    }
                }) 
                .then(res => { 
                    this.loader = false;
                    return res;
                })
                .catch(err => {    
                    this.loader = false;
                    // this.setNotification(
                    //     "error",
                    //     "Failed to make request. Ensure you have internet connection and try again."
                    // );
                    return {
                        state: 500,
                        payload: "Failed to make request. Ensure you have internet connection and try again."
                    }
                });
        },

        http_connect_get(endpoint, payload) {
            this.loader = true;
            return this.$http
                .get(endpoint, {params: payload})
                .then(res => {  
                    this.loader = false;
                    return res;
                })
                .catch(err => { 
                    this.loader = false; 
                     
                    if(err.toString().includes("Error: Request failed with status code 401")){
                        this.setNotification(
                            "error",
                            "Sorry your session has expired, please log in again."
                        );
                        this.$store.dispatch("logout");
                    } else {
                        this.setNotification(
                            "error",
                            "Failed to make request. Ensure you have internet connection and try again."
                        );
                    } 
                    return err;
                });
        },

        check_token(){
            var token = '';
            var tk = sessionStorage.getItem('vuex');  
            if(tk!=null){  
                token =JSON.parse(tk).session.token
            }
            return token;
        }
    },
    computed: {
        ...mapState(["notification", "session"]),
       
        objectsOnly: function () {
              var obj = [];
              if(this.$store.state.session.objects.length>0){
              this.$store.state.session.objects.map(element => {
                element.children.map(el => {  
                    if(moment().diff(el.dt_tracker, 'years') < 2)
                        obj.push(el); 
                });
              });}
              return obj;
        } 
    }
}

import { mapMutations, mapState, mapActions} from "vuex";
import moment from "moment";
export default common;